<template>
    <div class="footer">
        <p>
            <img src="@/assets/gongan.png" alt="">
            <span @click="handleClick">{{ t('footer.securityRecord') }}</span>
            &nbsp;&nbsp;
            <span @click="handleClick">{{ t('footer.icpRecord') }}</span>
        </p>
    </div>
</template>


<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const handleClick = () => {
    window.open('https://beian.miit.gov.cn/', '_blank')
}

</script>


<style scoped lang="scss">
.footer {
    width: 100vw;
    height: 30px;
    text-align: center;
    background-color: #999999;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;

    p {
        line-height: 30px;
        padding: 0;
        margin: 0;
        font-size: 14px;
        display: flex;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }
    }

    p:last-child {
        cursor: pointer;

    }
}
</style>
